// extracted by mini-css-extract-plugin
module.exports = {"root":"VideoSuggestionsPanel_SP_root__gy2oE","title":"VideoSuggestionsPanel_SP_title__3OkmU","list":"VideoSuggestionsPanel_SP_list__1ScNe"};